import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=6ab39681&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab39681",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab39681')) {
      api.createRecord('6ab39681', component.options)
    } else {
      api.reload('6ab39681', component.options)
    }
    module.hot.accept("./index copy.vue?vue&type=template&id=6ab39681&scoped=true", function () {
      api.rerender('6ab39681', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hsycjkfzjg/index copy.vue"
export default component.exports